import { render, staticRenderFns } from "./customerIndex.vue?vue&type=template&id=b039b126&scoped=true"
import script from "./customerIndex.vue?vue&type=script&lang=js"
export * from "./customerIndex.vue?vue&type=script&lang=js"
import style0 from "./customerIndex.vue?vue&type=style&index=0&id=b039b126&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039b126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b039b126')) {
      api.createRecord('b039b126', component.options)
    } else {
      api.reload('b039b126', component.options)
    }
    module.hot.accept("./customerIndex.vue?vue&type=template&id=b039b126&scoped=true", function () {
      api.rerender('b039b126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/customerIndex.vue"
export default component.exports